import "./BookingCalendarForDay.scss";
import moment, {Moment} from "moment";
import React, {useEffect, useState} from "react";

import {useTranslation} from "react-i18next";
import BookingCalendarPopup from "../BookingCalendarPopup/BookingCalendarPopup";
import {IClassEventReservation} from "../../../../models/ClassEventReservation";
import {$clientApi} from "../../../../http";
import Spinner from "../../../../components/Spiner/Spinner";


interface IBookingCalendarForDayProps {
    today: Moment
}

const BookingCalendarForDay: React.FC<IBookingCalendarForDayProps> = ({today}) => {
    const startDay = moment(today.clone()).startOf("day");
    const from = startDay.toISOString();
    const to = moment(startDay.clone()).endOf("day").toISOString();
    const hoursArray: { date: Moment, reservations: IClassEventReservation[] }[] = [...Array(24)].map((_, index) => {
        return {
            date: startDay.clone().add(index, "hours"),
            reservations: []
        }
    });
    const [itemHeight, setItemHeight] = useState(40);
    const {t} = useTranslation();

    const [showLoader, setShowLoader] = useState(true);
    const [hoursArrayWithEvents, setHoursArrayWithEvents] = useState(hoursArray);
    const [showDescriptionReservation, setShowDescriptionReservation] = useState<{
        isOpen: boolean,
        reservation: IClassEventReservation | null
    }>({isOpen: false, reservation: null})

    useEffect(() => {
        getClassEvents();
    }, [today]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 850) {
                setItemHeight(30);
            }

            if (window.innerWidth < 560) {
                setItemHeight(25);
            }
        };

        window.addEventListener('resize', handleResize);

        if (window.innerWidth < 850) {
            setItemHeight(30);
        }

        if (window.innerWidth < 560) {
            setItemHeight(25);
        }

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);


    const getClassEvents = async () => {
        setShowLoader(true);
        const response = await $clientApi.get<IClassEventReservation[]>(`api/class-events/reservation-for-customer?start=${from}&end=${to}&calendarView=day`);
        const newArray = hoursArray.map(el => {
            const reservations = response.data.filter((event: any) => moment(event.occuranceDate).isSame(moment(el.date), "hours"));
            return {
                date: el.date,
                reservations
            }
        })
        setHoursArrayWithEvents(newArray);
        setShowLoader(false);
    }

    const getNaming = (reservation: IClassEventReservation) => {
        if (reservation.type === "class-event" && reservation.waitingList?.length) {
            return "WaitingList";
        } else if (reservation.type === "class-event") {
            return "Booked";
        } else if (reservation.type === "reservation") {
            return "Appointment";
        } else {
            return "";
        }
    }

    if (showLoader) {
        return (
            <div className="loader-wrapper">
                <Spinner/>
            </div>
        )
    }

    return (
        <>
            <div className="booking-calendar-for-day">
                <div className="border"></div>
                <div className="container">
                    <div className="title-wrapper">
                        <h2 className="title">{today.format("dddd")}{" "}
                            <span>
                            {today.format("MMMM DD, yyyy")}
                        </span>
                        </h2>
                    </div>
                    <ul className="main-list">
                        {
                            hoursArrayWithEvents.map(el => {
                                return (
                                    <React.Fragment key={el.date.toISOString()}>
                                        <li className="main-list__item">
                                            <p className="item-time">{el.date.format("HH:mm")}</p>
                                            <div className="item-box" style={{height: `${itemHeight}px`}}>
                                                {
                                                    moment(el.reservations[0]?.occuranceDate).isSame(el.date, "hours") &&
                                                    <div className="reservations-wrapper">
                                                        {el.reservations.map(event => {
                                                            return (
                                                                <div key={event.id}
                                                                     className={`reservation-item ${getNaming(event)}`}
                                                                     style={{height: `${event.duration / 30 * itemHeight + (event.duration / 30 - 1) * 2}px`}}>
                                                                    <div className="reservation-item__header">
                                                                        <p className="time">{moment(event.occuranceDate).format("HH:mm")} - {moment(event.occuranceDate).add(event.duration, "minutes").format("HH:mm")}</p>
                                                                        <span
                                                                            className="type">{t(`${getNaming(event)}`)}</span>
                                                                    </div>
                                                                    <h4 className="title" onClick={() => {
                                                                        setShowDescriptionReservation({isOpen: true, reservation: event})
                                                                    }}>{event.trainningCourseName}</h4>

                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                }
                                            </div>
                                        </li>
                                        <li className="main-list__item">
                                            <div className="item-box" style={{height: `${itemHeight}px`}}>
                                            </div>
                                        </li>
                                    </React.Fragment>

                                )
                            })
                        }
                    </ul>
                </div>
            </div>
            {
                (showDescriptionReservation.isOpen && showDescriptionReservation.reservation) &&
                <BookingCalendarPopup
                    setShowDescriptionReservation={setShowDescriptionReservation}
                    reservation={showDescriptionReservation.reservation}
                    getClassEvents={getClassEvents}
                />
            }
        </>

    )
}

export default BookingCalendarForDay;